document.addEventListener('DOMContentLoaded', () => {
  const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  };

  const getCookie = (name) => {
    const nameEQ = `${name}=`;
    return document.cookie
      .split(';')
      .map(cookie => cookie.trim())
      .find(cookie => cookie.startsWith(nameEQ))
      ?.substring(nameEQ.length) || null;
  };

  const preventScroll = () => {
    document.body.style.overflow = 'hidden';
  };

  const enableScroll = () => {
    document.body.style.overflow = '';
  };

  // Check if the age verification cookie exists
  const ageVerified = getCookie('age_verified');
  const ageCheckerOverlay = document.getElementById('age-checker-overlay');

  // If no cookie exists, show the age verification modal and prevent scrolling
  if (!ageVerified) {
    ageCheckerOverlay.style.display = 'flex';
    preventScroll();
  }

  document.getElementById('age-checker-yes').addEventListener('click', () => {
    // Set cookie for 60 days
    setCookie('age_verified', 'true', 60);
    ageCheckerOverlay.style.display = 'none';
    enableScroll();
  });

  document.getElementById('age-checker-no').addEventListener('click', () => {
    // Show error message
    document.getElementById('age-checker-error').style.display = 'block';
  });
});
